export const ADD_ON_NAMES = {
  'voice-to-chart': 'Voice to Chart',
  'two-way-texting': 'Two-way Texting',
  'ai-receptionist': 'AI Receptionist',
} as const;
